<template>
  <b-icon v-if="isValue(-1)" :color="threshold[0].Color" scale="1" icon="caret-down-fill" />
  <b-icon v-else-if="isValue(0)" :color="threshold[1].Color" scale="0.666" icon="circle-fill" />
  <b-icon v-else-if="isValue(1)" :color="threshold[2].Color" scale="1" icon="caret-up-fill" />
</template>

<script>

export default {
  props: {
    actual:             { type: Number, required: true },
    last:               { type: Number, required: true },
    threshold:          { type: Array,  required: true },
  },

  methods: {
    isValue(value) {
      // if actual is larger than last, then === 1
      // if actual is smaller than last, then === -1
      // if actual is equal to last, then === 0
      return Math.sign(this.actual - this.last) === value;


    },
  }
}
</script>
